/**
 * Parses a string containing key = value pairs separated by semi-colons, ampersands or question marks and returns
 * them as an object
 * @param path
 */
export function getParametersFromString(path: string): { [key: string]: string } {
  const params: { [key: string]: string } = {};
  const entries = path.split(new RegExp('[; | & | ?]'))
    .filter((entry) => entry.indexOf('=') !== -1)
    .map(entry => entry.split('='));

  /* istanbul ignore next else */
  if (entries) {
    entries
      .filter((entry) => entry[0] && entry[1])
      .forEach((entry) => params[entry[0]] = entry[1]);
  }

  return params;
}

/**
 * Returns true with a chance determined by the given percentage, e.g. for percentage = 0.5, true will be returned for
 * approximately half of all calls
 * @param percentage percentage ad a decimal
 */
export function getChanceResult(percentage: number): boolean {
  return Math.random() <= percentage;
}

/**
 * Calculates the timeout based on the following parameters:
 * - Mobile / not mobile
 * - Effective network connection type or network connection type
 * - Round-trip time (rtt)
 * - Save Data (If data saver is enabled)
 * Maximum possible timeout:
 * - Mobile: 15s + rtt
 * - Not mobile: 13s + rtt
 */
export function getTimeout(): number {

  /* eslint-disable @typescript-eslint/no-explicit-any */
  const isMobileDevice: boolean = ('ontouchstart' in document.documentElement) || false;
        // nav: any = navigator;
        // connection: any = nav.connection ||
        //                   nav.mozConnection ||
        //                   nav.webkitConnection;

  let timeout = 8000;

  if (isMobileDevice) {
    timeout = 6000;
  }

  return timeout;

  // if (!connection) {
  //   return timeout;
  // }

  // if (connection.effectiveType && !connection.type) {
  //   if (connection.effectiveType === 'slow-2g') {
  //     timeout += 6000;
  //   } else if (connection.effectiveType === '2g') {
  //     timeout += 4000;
  //   } else if (connection.effectiveType === '3g') {
  //     timeout += 2000;
  //   }
  // }

  // if (connection.type && !connection.effectiveType) {
  //   if (connection.type !== 'ethernet' &&
  //       connection.type !== 'wifi' &&
  //       connection.type !== 'wimax') {
  //         timeout += 1000;
  //       }
  // }

  // if (connection.rtt) {
  //   if (connection.rtt >= 250) {
  //     timeout += connection.rtt;
  //   }
  // }

  // if (connection.saveData) {
  //   timeout += 1000;
  // }

  // /*
  //  * override mobile timeout from l.52 due to conversion testing
  //  * depending on the result lines 92ff could be removed to revert it
  //  */
  // if (isMobileDevice) {
  //   timeout = 2000;
  // }

  // return timeout;
}

export function isInternational(brand: string): boolean {
  return ['webde','gmx','gmxat','gmxch'].indexOf(brand) === -1;
}

const brandDomain = window.location.hostname.indexOf('co.uk') !== -1 ?
  window.location.hostname.split('.').slice(-3).join('.') :
  window.location.hostname.split('.').slice(-2).join('.');

export function getBrandDomain(): string {
  return brandDomain;
}
